import Alert from 'react-s-alert';

const config = {
  position: 'top-right',
  effect: 'slide',
  timeout: 3000
};

export class Notification {
  static info(msg) {
    Alert.info(msg, config);
  }

  static success(msg) {
    Alert.success(msg, config);
  }

  static warning(msg) {
    Alert.warning(msg, config);
  }

  static error(msg) {
    Alert.error(msg, config);
  }
}
